import React from 'react';

import { TableCard, Box } from 'vindi-ds-components';

import getPropsTagChipOverdue from '../utils/get_props_tag_chip_overdue';
import getPropsTagChipStatus from '../utils/get_props_tag_chip_status';

const TableCardSubscriptions = ({ subscriptions }) => (
  <Box display='flex' flexDirection='column' gridGap='24px' mb={2}>
    {subscriptions?.map((subscription) => {
      const propsTagChipOverdue = getPropsTagChipOverdue(subscription.overdue);
      const propsTagChipStatus = getPropsTagChipStatus(subscription.status);

      return (
        <TableCard.Container key={subscription.id}>
          <TableCard.TextWithAction label='Nome' value={subscription.customer_name} />
          <Box display='flex'>
            <TableCard.Text label='Cadastro' value={subscription.created_at} />
            <TableCard.Text label='Término' value={subscription.end_at} />
          </Box>
          <TableCard.Text label='Plano' value={subscription.plan_name} />
          <TableCard.Text label='Método de pagamento' value={subscription.payment_method_name} />
          <Box display='flex'>
            <TableCard.TextWithTagChip
              label='Inadimplência'
              value={propsTagChipOverdue.label}
              kind={propsTagChipOverdue.kind}
            />

            <TableCard.TextWithTagChip
              label='Status'
              value={propsTagChipStatus.label}
              kind={propsTagChipStatus.kind}
            />
          </Box>
        </TableCard.Container>
      );
    })}
  </Box>
);

export default TableCardSubscriptions;
